// extracted by mini-css-extract-plugin
export default {"CancelButton":"CancelButton_CancelButton__Goak7","CancelButton--rounded":"CancelButton_CancelButton--rounded__wwbCJ"};